import {mainQuery} from '@github-ui/react-core/future/main-query'
import {copilotAgentsAppBuilder} from '../../config/app-builder'
import type {CopilotAgentsSpacesPayload} from '../../types/copilot-agents-spaces-payload'
import {copilotChatPayloadBlockingRouteQuery} from '../copilot-chat-payload-route-query'

export function createCopilotAgentsSpaceRoute(path: string) {
  return copilotAgentsAppBuilder.createQueryRouteConfig('copilotAgentsSpaceRoute', {
    path,
    queries: [mainQuery<CopilotAgentsSpacesPayload>(), copilotChatPayloadBlockingRouteQuery],
  })
}

export const copilotAgentsSpaceRoute = createCopilotAgentsSpaceRoute('/copilot/agents/spaces/:owner/:number')
export const canonicalCopilotAgentsSpaceRoute = createCopilotAgentsSpaceRoute('/copilot/spaces/:owner/:number')
